import React, { useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationTipoCirurgiaSchema } from "../../schemas/validationSchema.ts";
import { TipoCirurgia } from "../../models/TipoCirurgia.ts";
import { Response } from "../../types/Api.ts";
import tipoCirurgiaService from "../../services/tipoCirurgiaService.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import Loading from "../Loading/index.tsx";
import { useNavigate } from "react-router-dom";

const CadastroTipoCirurgia: React.FC<{
  onAdd?: (response: Response<TipoCirurgia>) => void;
}> = ({ onAdd }) => {
  const { showFeedback } = useFeedback();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationTipoCirurgiaSchema),
  });

  const createTipoCirurgia = (data: any) => {
    return new TipoCirurgia(0, data.nome, data.observacao);
  };

  const onSubmit = async (data: any) => {
    const tipoCirurgia: TipoCirurgia = createTipoCirurgia(data);
    try {
      setIsLoading(true);
      const response: Response<TipoCirurgia> = await tipoCirurgiaService.create(
        tipoCirurgia
      );
      showFeedback(response.message, "success");
      if (onAdd) onAdd(response);
      else navigate("/tipo-cirurgia/listagem");
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome do tipo de cirurgia*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
        />
        <S.FullWidth>
          <textarea
            className="ds-textarea"
            placeholder="Observação"
            rows={4}
            {...register("observacao")}
          />
        </S.FullWidth>
      </S.InputGroup>

      <S.SubmitButton variant="contained" color="primary" type="submit">
        {isLoading ? <Loading color="white" /> : "Cadastrar"}
      </S.SubmitButton>
    </S.Form>
  );
};

export default CadastroTipoCirurgia;
